// import React, {useState} from "react";
// import ProfileContainer from "../components/ProfileContainer";
// import ProfileBrand from "../components/ProfileBrand";

// const MAX_LENGTH = 4;

// const TalentProfileBrandExperience = ({items}) => {

//     const [isBrandsOpen, setIsBrandsOpen] = useState(false);

//     return (
//         <div id="brand-experience" className="pt-2 pb-8">
//             <ProfileContainer>
//                 <div>
//                     <h4 className="textbold text-lg pb-6">Brand Experience  {!!items?.length && `(${items?.length})`}</h4>

//                     {!items?.length && (
//                         <div className="py-8 text-center">
//                             <p className="text-base">No Brands Available</p>
//                         </div>
//                     )}

//                         <div className="flex gap-4 flex-wrap">
//                         {items?.slice(0, isBrandsOpen ? items?.length : MAX_LENGTH).map(
//                             brand => <ProfileBrand key={brand.id} brand={brand} tooltipPlacement="bottom"/>
//                         )}
//                     </div>

//                     {items?.length > MAX_LENGTH && (
//                         <div className="pt-6 flex justify-end">
//                             <button
//                                 type="button"
//                                 className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
//                                 onClick={() => setIsBrandsOpen(!isBrandsOpen)}
//                             >
//                                 <p>{items?.length - MAX_LENGTH} {isBrandsOpen ? 'less' : 'more'}</p>
//                                 <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
//                                     <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isBrandsOpen })} />
//                                 </div>
//                             </button>
//                         </div>
//                     )}

//                 </div>
//             </ProfileContainer>
//         </div>

//     )
// }

// export default TalentProfileBrandExperience;

import React, { useState, useEffect, useRef } from 'react';
import ProfileContainer from "../components/ProfileContainer";
import ProfileBrand from "../components/ProfileBrand";

const ResponsiveFlexContainer = ({ children, minChildWidth = 100, gap = 16 }) => {
    const [visibleChildren, setVisibleChildren] = useState([]);
    const [hiddenChildren, setHiddenChildren] = useState([]);
    const [containerWidth, setContainerWidth] = useState(0);
    const [remainingAmount, setRemainingAmount] = useState(null)
    const [isOpen, setIsOpen] = useState(false);

    const containerRef = useRef(null);

    // Function to calculate how many items can fit
    const calculateVisibleItems = (isCurrentlyOpen) => {
        if (!containerRef.current) return;

        const width = containerRef.current.offsetWidth;
        setContainerWidth(width);

        let maxItems;
        let maxItemsIfOpen;

        if (width < 474) {
            maxItems = 4
        } else {
            maxItems = Math.floor(width / (minChildWidth + gap));
        }

        if (isCurrentlyOpen) {
            maxItemsIfOpen = children.length;
        }

        // Calculate how many items can fit in the container

        // Create arrays of visible and hidden children
        const childrenArray = React.Children.toArray(children);
        const visible = childrenArray.slice(0, maxItemsIfOpen || maxItems);
        const hidden = childrenArray.slice(maxItemsIfOpen || maxItems);

        setVisibleChildren(visible);
        setHiddenChildren(hidden);
        setRemainingAmount(childrenArray.slice(maxItems))
    };

    // Initialize and handle resize
    useEffect(() => {
        calculateVisibleItems(isOpen);

        const handleResize = () => {
            calculateVisibleItems(isOpen);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [children, minChildWidth]);


    const onChange = () => {
        calculateVisibleItems(!isOpen);
        setIsOpen(!isOpen)
    }

    return (
        <div className="relative">
            <div
                ref={containerRef}
                className="flex flex-row gap-4 flex-wrap items-center justify-around"
            >
                {visibleChildren}

                {/* Show a "more" indicator if there are hidden items */}

            </div>
            {/* {hiddenChildren.length > 0 && (
                <div className="flex items-center justify-center ml-2">
                    <div className="relative group">
                        <button className="bg-gray-200 rounded-full w-8 h-8 flex items-center justify-center text-gray-600 hover:bg-gray-300">
                            +{hiddenChildren.length}
                        </button>

                        <div className="absolute left-0 mt-2 w-auto hidden group-hover:block bg-white shadow-lg rounded p-2 z-10">
                            <div className="flex flex-col gap-2">
                                {hiddenChildren}
                            </div>
                        </div>
                    </div>
                </div>
            )} */}

            {/* <div className="mt-4 text-sm text-gray-500">
                Container width: {containerWidth}px | Visible items: {visibleChildren.length} | Hidden items: {hiddenChildren.length}
            </div> */}

            <div className="pt-6 flex justify-end">
                {!!remainingAmount?.length && (
                    <button
                        type="button"
                        className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                        onClick={onChange}
                    >
                        <p>{remainingAmount?.length} {isOpen ? 'less' : 'more'}</p>
                        <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                            <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isOpen })} />
                        </div>
                    </button>
                )}
            </div>

        </div>
    );
};


const TalentProfileBrandExperience = ({ items }) => {
    return (
        <div id="brand-experience" className="pt-2 pb-8">

            <ProfileContainer>
                <h4 className="textbold text-lg pb-6">Brand Experience  {!!items?.length && `(${items?.length})`}</h4>

                <div className="">
                    <ResponsiveFlexContainer minChildWidth={142}>

                        {items?.map(
                            brand => <ProfileBrand key={brand.id} brand={brand} tooltipPlacement="bottom" />
                        )}
                    </ResponsiveFlexContainer>

                </div>
            </ProfileContainer>
        </div>
    );
};

export default TalentProfileBrandExperience;